import Resource from '@/services/resources/common';

export default class ZoneTypeResource extends Resource {
  constructor(entrypoint = '/location_types', alias = 'LocationType') {
    super(entrypoint, alias);
  }
}
